<script lang="ts" setup>
import logo from './images/logo.svg';

const props = defineProps<{
  small?: boolean;
  smallest?: boolean;
  center?: boolean;
}>();
</script>

<template>
  <div
    :class="[
      $style.loader,
      {
        [$style.loader_small!]: props.small,
        [$style.loader_smallest!]: props.smallest,
        [$style.loader_center!]: props.center,
      },
    ]"
  >
    <div
      :class="$style.image"
      :style="{ backgroundImage: `url(${logo})` }"
    ></div>
    <div :class="$style.text">Загрузка...</div>
  </div>
</template>

<style lang="scss" module>
.loader {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;
  gap: 28px;
  margin-top: 20px;
  margin-bottom: 20px;

  &_small {
    gap: 14px;
    .image {
      flex-shrink: 0;
      width: 100px;
      height: 100px;
      background-size: 50%;

      &::before {
        border-width: 1px;
      }
      &::after {
        border-width: 2px;
      }
    }
  }
  &_smallest {
    gap: var(--space-1x);
    .image {
      flex-shrink: 0;
      width: 50px;
      height: 50px;
      background-size: 50%;

      &::before {
        border-width: 1px;
      }
      &::after {
        border-width: 2px;
      }
    }
  }
  &_center {
    height: 100%;
    justify-content: center;
  }
}

.image {
  position: relative;
  width: 300px;
  height: 300px;
  border-radius: 50%;
  background-repeat: no-repeat;
  background-position: center;
  background-size: auto;

  &::before {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    border: 2px solid rgba(204, 7, 30, 0.2);
    border-radius: 50%;
  }

  &::after {
    content: '';
    position: absolute;
    top: -1px;
    left: -1px;
    width: calc(100% + 2px);
    height: calc(100% + 2px);
    border: 4px solid transparent;
    border-top-color: var(--color-red-1);
    border-right-color: var(--color-red-1);
    border-radius: 50%;
    animation: spin 1.5s cubic-bezier(0.48, 0.29, 0.17, 0.8) infinite;
  }
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.text {
  @include text_body2;
  color: var(--color-black-1);
}
</style>
